<template>
  <div class="zbjl-box">
    <div class="zbjl-container" ref="listContainer" @scroll="handleScroll">
      <!-- 顶部步骤引导 -->
      <div class="zbjl-steps">
        <div class="zbjl-step zbjl-step-left" @click="handleShenqing">
          <span class="zbjl-step-num">1</span>
          <span class="zbjl-step-text">{{$t('all.shenqingzhibo')}}</span>
        </div>
		<img src="../../../assets/image/jindu_heng@2x.png" alt="" />
        <div class="zbjl-step zbjl-step-right" @click="handleKaishi">
          <span class="zbjl-step-num1">2</span>
          <span class="zbjl-step-text">{{$t('all.kaishizhibo')}}</span>
        </div>
      </div>
      <!-- 分类tabs -->
      <!-- <div class="zbjl-tabs">
        <div 
          :class="tabIndex === index ? 'zbjl-tab-active' : 'zbjl-tab'" 
          v-for="(item, index) in categoryList" 
          :key="index"
          @click="handleTabChange(index)"
        >{{item.name}}</div>
      </div> -->
	  <div class="zbjl-title">
	  	<div class="zbzx-title-box">
	  		<span class="zbzx-title-span">{{$t('all.zhibojilu')}}</span>
	  		<span class="zbzx-title-span1"></span>
	  	</div>
	  </div>
      <!-- 列表 -->
      <div class="zbjl-list">
        <zbList v-for="(item,index) in list" :key="index" :data="item" :type="1"></zbList>
      </div>
      <div class="zbjl-kong" v-if="!isLoading && loaded && list.length === 0">
      	<kong></kong>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserLiveRecordList } from "@/api/zhibo";
import zbList from "../../../components/zbList/zbList.vue";
import kong from "../../../components/kong/kong.vue";
export default {
  components: { zbList, kong },
  data() {
    return {
      tabIndex: 0,
      categoryList: [],
      list: [],
      queryParams: {
        page: 1,
        size: 20,
        viewUserId: ''
      },
      hasMore: true,
      isLoading: false,
      loaded: false
    };
  },
  mounted() {
    this.$store.commit('changeCount', 1);
    this.categoryList = [
      { name: this.$t('all.quanbu') },
      { name: this.$t('all.yinyuedaren') },
      { name: this.$t('all.wudaodaren') },
      { name: this.$t('all.yanzhi') }
    ];
    this.queryParams.viewUserId = this.$store.state.userId;
    this.getList();
  },
  methods: {
    handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.list = [];
      this.loaded = false;
      this.getList();
    },
    async getList() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;
      try {
        const response = await getUserLiveRecordList(this.queryParams);
        const newList = response.rows || [];
        if (this.queryParams.page === 1) {
          this.list = newList;
        } else {
          this.list = [...this.list, ...newList];
        }
        const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
        this.hasMore = this.queryParams.page < totalPages;
      } catch (error) {
        console.error("获取直播记录失败:", error);
      } finally {
        this.isLoading = false;
        this.loaded = true;
      }
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore) return;
      const container = this.$refs.listContainer;
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
      if (isAtBottom) {
        this.queryParams.page++;
        this.getList();
      }
    },
    handleShenqing() {
      this.$router.push('/zhibozhongxin');
    },
    handleKaishi() {
      this.$router.push('/kaishizhibo');
    }
  }
};
</script>

<style scoped lang="scss">
@import "./zhibojilu.css";
</style>



// WEBPACK FOOTER //
// zhibojilu.vue?3bb31648